<template>
  <div>
    <b-card title="ثبت تیکت">
      <b-alert :show="errors.length > 0" variant="danger">
        <p v-for="x in errors" v-bind:key="x">{{ x }}</p>
      </b-alert>
      <b-form>
        <b-form-group id="des-gr" label="پاسخ های آماده:" label-for="des">
          <MDDropdown v-bind:group="120" @input="change"></MDDropdown>
        </b-form-group>
        <b-form-group
          id="input-group-1"
          label="موضوع تیکت *: "
          label-for="input-1"
        >
          <b-form-input
            id="input-1"
            required
            v-model="Ticket.subject"
            placeholder="عنوان تیکت "
          ></b-form-input>
        </b-form-group>

        <div>
          <b-row>
            <b-col>
              <b-form-group id="des-gr" label="اهمیت:" label-for="des">
                <MDDropdown
                  v-bind:group="2"
                  v-model="Ticket.mdid2_periority"
                ></MDDropdown>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                id="input-group-3"
                label="دپارتمان: "
                label-for="input-3"
              >
                <b-form-select
                  id="input-3"
                  v-model="Ticket.department_id"
                  :options="departments"
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col>
              <user-list v-model="user_id"></user-list>
            </b-col>
          </b-row>

          <b-form-group
            id="input-group-4"
            label="متن تیکت: "
            label-for="input-4"
          >
            <b-form-textarea
              id="input-4"
              v-model="Ticket.text"
              placeholder="متن تیکت را اینجا تایپ کنید"
              rows="8"
            ></b-form-textarea>
          </b-form-group>
        </div>
        <div class="row">
                <div
                  class="col-md-3 mt-3"
                  v-for="(x, index) in Ticket.files"
                  v-bind:key="x.file_id"
                >
                  <!-- <b-img :src="'https://api.shepa.com/api/file/' + x.file_id" fluid></b-img> -->
                  <b-button
                    class="mr-5"
                    @click="delete_attachment(index)"
                    size="sm"
                  >
                    <b-icon icon="trash"></b-icon>
                  </b-button>
                  <a
                    target="_blank"
                    :href="'https://api.shepa.com/api/file/' + x.file_id"
                    >پیوست شماره {{ index + 1 }}</a
                  >
                </div>
              </div>
        <div class="mt-3">
          <b-col cols="4">
            <div>
              <b-form-group
                id="input-group-4"
                label="اضافه کردن پیوست: "
                label-for="input-4"
              >
                <fileUploader
                  v-model="file"
                  v-bind:fileUploaded="fileUploaded"
                ></fileUploader>
              </b-form-group>
            </div>
          </b-col>
        </div>

        <b-row class="mt-3">
          <b-col>
            <b-button
              class="mr-3"
              variant="danger"
              @click="$router.push('tickets')"
              >بازگشت</b-button
            >
            <b-button class="mr-3" variant="success" @click="submitTicket"
              >ثبت تیکت</b-button
            >
          </b-col>
        </b-row>
      </b-form>
    </b-card>
  </div>
</template>
<style>
.my-auto {
  margin-top: auto;
  margin-bottom: auto;
}
html .modal-dialog {
  max-width: 1000px;
}
</style>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import httpHelper from "@/helpers/httpHelper";
import fileUploader from "../../components/fileUploader";
import MDDropdown from "../../components/MDDropdown";
import UserList from "../../components/UserList";

export default {
  name: "addTicket",
  components: {
    fileUploader,
    MDDropdown,
    "user-list": UserList,
  },
  data: function () {
    return {
      errors: [],
      departments: [],
      ticket_subject: null,
      ticket_content: null,
      ticket_department: null,
      ticket_priority: 6,
      users: [],
      file: "",
      user_id: 0,
      Ticket: {
        subject: "",
        department_id: 2,
        mdid2_periority: 6,
        text: "",
        mdid1_status: 1,
        files: [],
        user_id: null,
      },
    };
  },
  watch: {
    user_id: function (newVal, oldVal) {
      if (newVal != null) {
        this.Ticket.user_id = newVal;
      }
    },
    file: function(newVal, oldVal) {
      if (newVal != null) {
        this.Ticket.files.push({ file_id: newVal });
      }
    },
  },
  created() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "تیکت ها", route: "/tickets" },
      { title: "ثبت تیکت" },
    ]);
    httpHelper.setAuth();

    httpHelper
      .getData("/departments")
      .then((response) => {
        this.departments = response.result.map((item) => {
          return { value: item.id, text: item.name };
        });
      })
      .catch((error) => {})
      .finally(() => {});
  },
  methods: {
    fileUploaded: function () {
      this.Ticket.files.push({ file_id: this.file });
      this.file = "";
    },

    submitTicket: function () {
      this.errors = [];
      httpHelper
        .postData("tickets", this.Ticket)
        .then((response) => {
          if (response.success) {
            this.$router.push("/ticketDetails/" + response.result);
          } else {
            for (const key in response.error) {
              if (response.error.hasOwnProperty(key)) {
                const element = response.error[key];
                element.forEach((er) => {
                  this.errors.push(er);
                });
              }
            }
          }
        })
        .catch((error) => {})
        .finally(() => {});
    },
    delete_attachment(index) {
      this.Ticket.files.splice(index, 1);
    },
    change(e) {
      Object.assign(this.Ticket, {
        subject: e[0].text,
        text: e[0].description,
      });
    },
  },
  mounted() {},
};
</script>